<template>
    <div id="addCharge" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> {{title}}</div>
                    <router-link class="btn btn-secondary pull-right" href="javascript:void(0)" v-bind:to="'/extra-charge/list'" >
                        <i class="fp-back"> </i> Back
                    </router-link>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="chargeForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="charge_name">Charge Name :</label>                                        
                                        <input type="text" class="form-control" v-model="charge_name" id="charge_name" name="charge_name">
                                        <div class="field-error">{{charge_name_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="amount">Charge Amount:</label>
                                        <input type="text" class="form-control" v-model="amount" id="amount" name="amount" @keypress="isAmountCheck($event)">
                                        <div class="field-error">{{amount_msg}}</div>
                                    </div>
                                </div>
                                <ul v-if="formerrors.length">
                                    <li v-for = "formerror in formerrors" :key="formerror.id" v-bind:class="msgClass" >{{formerror}}</li>
                                </ul>
                                <div class="form-group alert-success">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createChargeBtn" class="btn btn-primary" v-on:click.prevent="AddCharge('')" >
                                    <i class="fp-save"> </i> Save
                                    </button>
                                    <button v-if="add_charge_id == 0" type="submit" id="createAndContinueChargeBtn" class="btn btn-tertiary" v-on:click.prevent="AddCharge(flag='continue')" >
                                        <i class="fp-save-continue"> </i> Save and Continue
                                    </button>
                                    <button id="cancelChargeBtn" class="btn btn-tertiary" v-on:click.prevent="listcharge()" >
                                        <i class="fp-close"> </i> Cancel
                                    </button>    
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

    import Vue from "vue";
    
    import {commonMixins} from '../../mixins/commonMixins';
    
    
    
    export default {
        name: "addCharge",
        metaInfo() {
            return {title: (this.$route.params.id > 0)? "Update Extra Charge | " +process.env.COPYRIGHT_NAME : "Create Extra Charge | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins],
        data: () => ({
            editCharge:false,
            title:"Add Charge",
            formerrors: [],
            Registerchargebtn:"Add",
            cancelbtn:false,
            msgClass: "",
            charge_identifier:"",
            charge_name:"",
            charge_type:null,
            rate:"",
            charge_identifier_msg:"",
            charge_name_msg:"",
            charge_type_msg:"",
            rate_msg:"",
            add_charge_id:0,
            permissions:[],
            cantAccessPage:"",
            loading:false,
            amount:"",
            amount_msg:"",
        }),
        watch:{
            permissions: function(permission){
                var self = this;
                permission.forEach(function (permissions) {
                    if(self.add_charge_id > 0) {
                        if (permissions.name == 'add_charges') {
                            self.cantAccessPage = true;
                        }
                    }else{
                        if(permissions.name == 'add_charges') {
                            self.cantAccessPage = true;
                        }
                    }

                });
                if(self.cantAccessPage == ''){
                    self.cantAccessPage = false;
                }
            }
        },
        mounted: function() {

            var self = this;

            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[3])
            {
                this.add_charge_id = segments[3];
            }


            if(this.$route.query.token == 'list'){

                self.cancelbtn = true;
            }

            if ( this.add_charge_id != 0 ) {

                //change text of button
                setTimeout(function(){
                    $("#createChargeBtn").text("Update");
                },1000);

                this.title = "Update Charge";
                self.editCharge = true;

                //get contact object
                $.ajax({
                    url: process.env.ROOT_API +"/get_extra_charge?id="+self.add_charge_id,
                    type: "GET",
                    crossDomain: true,
                    dataType: "json",
                    headers: this.ajxHeaders,

                    success: function(data) {
                        //console.log(data.content[0]["id"]);
                        if (data.status == "success") {
                            //console.log(data.content);
                            self.charge_name = data.content.name;
                            
                            self.amount = data.content.amount;


                        }
                    },
                    error: function(jqXHR, exception) {
                        self.generateStatusCodeMessage(jqXHR,false,'get-extra-charge-by-id')
                    }
                });
            } else {
                setTimeout(function(){
                    $("#createChargeBtn").text("Save");
                },500);
            }

            self.getPermissions();

        },
        methods:{

            AddCharge: function(flag) {

                var self = this;

                // this.amount = $("#charge_identifier").val();
                // this.charge_name = $("#charge_name").val();

                //   var formerrors_msg = "";
                this.formerrors = [];
                self.amount_msg = "";
                self.charge_name_msg = "";


                if (!this.charge_name) {
                    self.charge_name_msg = "Charge Name Required.";
                }

                if (!this.amount) {
                    self.amount_msg = "Amount Required.";
                }
               
                if (self.amount_msg == "" && self.charge_name_msg == "") {

                    var fields = $("#chargeForm").serializeArray();
                    // fields.push({name: 'user_id', value: userId });
                    if(self.add_charge_id != 0){
                        fields.push({name: 'id', value: self.add_charge_id });
                    } else {
                        $("#createAndContinueChargeBtn").prop("disabled",true);
                        $("#createAndContinueChargeBtn").text("Processing...");
                    }

                    $("#createChargeBtn").prop("disabled",true);
                    $("#cancelChargeBtn").prop("disabled",true);

                    $("#createChargeBtn").text("Processing...");

                    $.ajax({
                        url: process.env.ROOT_API + "/add_extra_charge",
                        type: "POST",
                        crossDomain: true,
                        headers: this.ajxHeaders,
                        dataType: "json",
                        data: fields,
                        success: function(data) {

                            if(self.add_charge_id == 0){

                                $("#createChargeBtn").text("Save");
                                $("#createAndContinueChargeBtn").text("Save and Continue");
                                $("#createAndContinueChargeBtn").prop("disabled",false);
                            } else {
                                $("#createChargeBtn").text("Update");
                            }

                            $("#createChargeBtn").prop("disabled",false);
                            $("#cancelChargeBtn").prop("disabled",false);

                            if (data.status == "success") {

                                self.formerrors.push(data.message);
                                if ( flag != "continue") {
                                    self.$router.push("/extra-charge/list");
                                }else {
                                    self.charge_name = "";
                                    self.amount = '';
                                }

                                self.msgClass = "success";
                                // $("#chargeForm").trigger("reset");


                            } else if (data.status == "error") {

                                //add errors in formerror array
                                for(var i=0; i<data.content.length; i++) {
                                    self.formerrors.push(data.content[i]);
                                }

                                self.msgClass = "error";
                            }
                        },
                        error: function(jqXHR, exception) {

                            if(self.add_charge_id != undefined){
                                $("#createChargeBtn").text("Save");
                                $("#createAndContinueChargeBtn").text("Save and Continue");
                                $("#createAndContinueChargeBtn").prop("disabled",false);
                            } else {
                                $("#createChargeBtn").text("Update");
                            }

                            $("#createChargeBtn").prop("disabled",false);
                            $("#cancelChargeBtn").prop("disabled",false);

                            self.generateStatusCodeMessage(jqXHR,true,'extra-charge-add')
                        }
                    });
                } else {
                    console.log($(".error_style").length);
                    self.msgClass = "error";
                }
            },
            listcharge:function(){
                var self = this;

                self.$router.push("/extra-charge/list");

            },
            formatString(data){
                var self = this;
                var value = data.replace(/_/g," ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function(letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },

        }

    }
</script>



// WEBPACK FOOTER //
// src/components/charge/ExtraChargeCreate.vue